<form class="notifications" [formGroup]="form">
  <div>
    {{ 'components.messenger.labels.notificationsDescription' | translate }}
  </div>

  <app-field-wrapper
    [class.tui-skeleton]="loading"
    [text]="'components.messenger.labels.sendPushNotifications ' | translate"
    [size]="'s'"
  >
    <app-toggle formControlName="sendPushNotifications"></app-toggle>
  </app-field-wrapper>

  <app-field-wrapper
    [class.tui-skeleton]="loading"
    [text]="'components.messenger.labels.showMessageInPush ' | translate"
    [size]="'s'"
  >
    <app-toggle formControlName="showMessageInPush"></app-toggle>
  </app-field-wrapper>
</form>
